import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1, // 실패 시 재시도 횟수
      refetchOnWindowFocus: false, // 윈도우 포커스 시 자동 refetch 비활성화
      staleTime: 5 * 60 * 1000, // 5분 (데이터가 fresh한 시간)
      gcTime: 10 * 60 * 1000, // 10분 (캐시 유지 시간)
    },
    mutations: {
      retry: 0, // mutation은 재시도 안 함
    },
  },
});